import {DetailDialogController} from '../../controller/DetailDialogController';
import {AccountService} from '../../services/AccountService';

import './confirmation.html';

/** @ngInject */
export class DeleteConfirmationController extends DetailDialogController {
    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, arsMainDependencies.$state._params.restUrl,
            arsMainDependencies.$state._params.service ?
                arsMainDependencies.$state._params.service : new AccountService(userService));

        this.selectedItems = this.state._params.ids;
    }

    delete() {
        super.delete(this.selectedItems);
    }
}
